<!-- 关联产品 -->
<template>
  <div>
    <Dialog
      title="选择产品"
      :modelValue="modelValue"
      @onClosed="handleClosed"
      @onConfirm="handleConfirm"
      width="60%"
    >
      <template #content>
        <Table
          ref="tableRef"
          :data="tableData"
          :columns="columns"
          height="500"
          :showSearchIcon="true"
          :searchAttrName="searchAttrName"
          :total="total"
          :loading="loading"
          :isSelect="true"
          @onSearch="handleSearch"
        >
          <template #funBtn>
            <el-row :gutter="8">
              <el-col :span="1.5">
                <el-button type="primary" plain icon="Plus" @click="handleAdd"
                  >新增</el-button
                >
              </el-col>
            </el-row>
          </template>
        </Table>
      </template>
    </Dialog>
    <AddUpdate
      v-model="addUpdateOpen"
      :data="addUpdateData"
      :appendToBody="true"
      title="新增"
      @success="handleSuccess"
    />
  </div>
</template>

<script setup>
import Dialog from "@/components/Element/Dialog";
import Table from "@/components/Element/Table";
import { getCustomTableCols } from "@/tableColumn";
import { listProduct } from "@/api/warehouse/product";
import { ref } from "vue";
import AddUpdate from "@/views/warehouse/basicData/productInfo/AddUpdate.vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const tableData = ref();
const total = ref(0);
const loading = ref(false);
const tableRef = ref(null);

const addUpdateOpen = ref(false);
const addUpdateData = ref({});

const handleSearch = (data) => {
  loading.value = true;
  listProduct(data)
    .then((res) => {
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .catch((res) => {})
    .finally(() => {
      loading.value = false;
    });
};

const emits = defineEmits(["update:modelValue", "success"]);

const handleClosed = () => {
  emits("update:modelValue", false);
};

const handleConfirm = () => {
  const selectData = tableRef.value.getSelectedRows();
  emits("success", selectData);
  handleClosed();
};

const searchAttrName = ["productName", "productType", "usageType"];
// 新增产品
const handleAdd = () => {
  addUpdateData.value = {};
  addUpdateOpen.value = true;
};
// 新增成功
const handleSuccess = () => {
  tableRef.value.onSearch();
};

const cleanSelect = () => {
  if (tableRef.value !== null) {
    tableRef.value.cleanSelect();
  }
};

const columns = getCustomTableCols([
  "productName",
  "productType",
  "supplier",
  "supplierModel",
  "internalModel",
  "usageType",
  // "productUnit",
]);

defineExpose({
  cleanSelect,
});
</script>

<style lang="scss" scoped></style>
